import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'pr-pricing-type-help',
  templateUrl: './pricing-type-help.component.html',
  styleUrls: ['./pricing-type-help.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PricingTypeHelpComponent {}
